import { render, staticRenderFns } from "./over400Order.vue?vue&type=template&id=12650821&scoped=true&"
import script from "./over400Order.vue?vue&type=script&lang=js&"
export * from "./over400Order.vue?vue&type=script&lang=js&"
import style0 from "./over400Order.vue?vue&type=style&index=0&id=12650821&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12650821",
  null
  
)

export default component.exports